"use client";

import { useTranslation } from "react-i18next";

/**
 * EPIC-022 STORY-629 — small badge rendered next to display names
 * everywhere a user is referenced: post feed cards, post detail
 * header, /u/[username] header. Distinct from the PI tier badge
 * (performance-driven) — this one is admin-curated for domain
 * credibility.
 *
 * Pure presentation: caller decides whether to render based on
 * `user.verifiedExpert`.
 */
export function VerifiedExpertBadge({ size = "sm" }: { size?: "sm" | "md" }) {
  const { t } = useTranslation();
  const padding = size === "md" ? "px-1.5 py-[2px]" : "px-1 py-[1px]";
  const fontSize = size === "md" ? "text-[10px]" : "text-[9px]";
  return (
    <span
      title={t("verifiedExpertBadge.tooltip")}
      className={`inline-flex items-center gap-0.5 rounded-[4px] border font-bold uppercase tracking-[0.4px] ${padding} ${fontSize}`}
      style={{
        borderColor: "var(--color-brand)",
        color: "var(--color-brand)",
        background: "var(--color-brand-tint)",
      }}
    >
      ✓ {t("verifiedExpertBadge.label")}
    </span>
  );
}
